export default function BadRequestError(payload, message) {
  this.name = 'BadRequestError';
  this.message = message;
  this.error = payload; // Legacy
  this.errors = payload;
  this.stack = (new Error()).stack;
}
BadRequestError.prototype = new Error();
